<template>
  <CartBase
    :items="items"
    :order-config="orderConfig"
    :container-classes="[
      'fixed top-0 right-0 h-full w-full max-w-md bg-white shadow-2xl transform transition-transform duration-300 ease-in-out flex flex-col',
      isOpen ? 'translate-x-0' : 'translate-x-full'
    ]"
    container-style="z-index: 60"
    :show-pin-button="true"
    pin-button-type="pin"
    :show-close-button="true"
    :is-store-closed="isStoreClosed"
    :on-pin="handlePin"
    :on-update-quantity="onUpdateQuantity"
    :on-remove-item="onRemoveItem"
    :on-edit-item="onEditItem"
    :on-checkout="onCheckout"
    :on-close="onClose"
  >
    <!-- Overlay -->
    <template #overlay>
      <div
        :class="[
          'fixed inset-0 bg-black/50 backdrop-blur-sm transition-opacity',
          isOpen ? 'opacity-100' : 'opacity-0'
        ]"
        :style="
          isOpen
            ? 'z-index: 55; pointer-events: auto;'
            : 'z-index: 55; pointer-events: none;'
        "
        @click="onClose"
      />
    </template>
  </CartBase>
</template>

<script>
import CartBase from "./CartBase.vue";

export default {
  name: "CartDrawer",
  components: {
    CartBase
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    orderConfig: {
      type: Object,
      required: true
    },
    isStoreClosed: {
      type: Boolean,
      default: false
    },
    onUpdateQuantity: {
      type: Function,
      required: true
    },
    onRemoveItem: {
      type: Function,
      required: true
    },
    onEditItem: {
      type: Function,
      default: null
    },
    onCheckout: {
      type: Function,
      required: true
    },
    onClose: {
      type: Function,
      required: true
    },
    onPin: {
      type: Function,
      required: true
    }
  },
  watch: {
    isOpen(open) {
      this.toggleBodyScrollLock(open);
    }
  },
  mounted() {
    if (this.isOpen) {
      this.toggleBodyScrollLock(true);
    }
  },
  beforeDestroy() {
    this.toggleBodyScrollLock(false);
  },
  methods: {
    handlePin() {
      this.onPin();
      this.onClose();
    },
    toggleBodyScrollLock(lock) {
      if (typeof window === "undefined") return;
      // Only lock the page scroll on mobile, where the cart is a full
      // overlay drawer. On desktop the cart is a pinned sidebar.
      const isMobile = window.matchMedia("(max-width: 767px)").matches;
      const value = lock && isMobile ? "hidden" : "";
      // Lock both <html> and <body>: depending on layout either one can be
      // the viewport scroll container.
      document.documentElement.style.overflow = value;
      document.body.style.overflow = value;
    }
  }
};
</script>
